import type { RefObject } from 'react';
import { Search } from '@kyruus/search-sdk';

import type {
  MarketableLocation,
  SearchQuery,
  ExtendedProvider,
  Profile
} from 'Src/types';

export const STATES = {
  location: '@states/LOCATION',
  providers: '@states/PROVIDERS',
  initializing: '@states/INITIALIZING',
  error: '@states/ERROR',
  success: '@states/SUCCESS',
  pending: '@states/PENDING'
} as const;

export const EVENTS = {
  fetchLocationSuccess: 'xstate.done.actor.fetchLocation',
  fetchLocationError: 'xstate.error.actor.fetchLocation',
  fetchProvidersSuccess: 'xstate.done.actor.fetchProviders',
  fetchProvidersError: 'xstate.error.actor.fetchProviders',
  loadMoreProviders: 'FETCH_MORE_PROVIDERS',
  newProvidersSearch: 'NEW_PROVIDERS_SEARCH'
} as const;

export type LocationResult = { data: MarketableLocation };

export type ProvidersResult = {
  data: {
    _metadata: {
      total_providers: number;
    };
    _result: Profile[];
  };
};

export type NewProvidersSearch = {
  data: {
    currentQuery: SearchQuery;
  };
};

export interface LocationContext {
  currentQuery: SearchQuery;
  error?: unknown;
  fetchLocation: (props: {
    locationId: string;
    searchSDK: RefObject<Search>;
  }) => Promise<LocationResult['data']>;
  fetchProvidersByLocation: (
    locationId: string,
    currentQuery: SearchQuery
  ) => Promise<ProvidersResult['data']>;
  location?: MarketableLocation;
  locationId: string;
  providers?: ExtendedProvider[];
  providersError?: unknown;
  providersPage: number;
  totalProviders?: number;
  searchSDK: RefObject<Search>;
}

export type LocationEvent =
  | {
      type: typeof EVENTS.fetchLocationSuccess;
      output: LocationResult['data'];
    }
  | { type: typeof EVENTS.fetchLocationError; error: unknown }
  | {
      type: typeof EVENTS.fetchProvidersSuccess;
      output: ProvidersResult['data'];
    }
  | { type: typeof EVENTS.fetchProvidersError; error: unknown }
  | { type: typeof EVENTS.loadMoreProviders }
  | ({ type: typeof EVENTS.newProvidersSearch } & NewProvidersSearch);
